import type {SerializedError} from './types'

const MAX_CAUSE_DEPTH = 3

const getKind = (error: Error): string => (error.name === 'Error' ? error.constructor.name : error.name)

const UNSERIALIZABLE = '[unserializable value]'

const safeString = (value: unknown): string => {
  try {
    return String(value)
  } catch {
    return UNSERIALIZABLE
  }
}

const stringifyNonError = (value: unknown): string => {
  if (typeof value !== 'object' || value === null) {
    return safeString(value)
  }

  try {
    return JSON.stringify(value) ?? safeString(value)
  } catch {
    return safeString(value)
  }
}

const serializeAtDepth = (value: unknown, depth: number): SerializedError => {
  if (!(value instanceof Error)) {
    return {kind: 'NonError', message: stringifyNonError(value)}
  }

  const serialized: SerializedError = {kind: getKind(value), message: value.message, stack: value.stack}

  if (value.cause !== undefined && depth < MAX_CAUSE_DEPTH) {
    serialized.cause = serializeAtDepth(value.cause, depth + 1)
  }

  return serialized
}

export const serializeError = (value: unknown): SerializedError => serializeAtDepth(value, 0)
